import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { PrismDataBar } from '@mylighthouse/prism-ember';
import type { BarData } from '@mylighthouse/prism-ember/types/components/prism/data-bar';
import { formatNumber, t } from 'ember-intl';
import { notEq } from 'ember-truth-helpers';
import type { RevenueInsightSegmentationValue } from 'lumen/models';

interface HotelAndMarketRevenueInsightSegmentationSegmentationItemCurrentValueSignature {
  Args: {
    activateSearch: () => void;
    isStriped?: boolean;
    item: RevenueInsightSegmentationValue;
    targetValue: number | null;
    targetValuePercentage?: number;
    value: number;
    valueProgressBarData: BarData[];
  };
}

const HotelAndMarketRevenueInsightSegmentationSegmentationItemCurrentValue =
  <template>
    {{! template-lint-disable no-unnecessary-concat }}
    {{#if @item.isAggregatedRow}}
      <div class="title-and-value-container text-200--bold">
        <span class="progress-bar-title">{{@item.displayValue}}</span>
        <span class="progress-bar-value">{{formatNumber
            @value
            maximumFractionDigits=0
            minimumFractionDigits=0
          }}</span>
      </div>
      <div class="flex flex-row">
        <button
          class="prism-link link-button--unstyled"
          data-event-id="revenue-insight-search-from-aggregated-row"
          type="button"
          {{on "click" @activateSearch}}
        >
          {{t "revenue_insight.breakdowns.aggregated_row_search"}}
        </button>
      </div>
    {{else}}
      <PrismDataBar
        @data={{@valueProgressBarData}}
        @isStriped={{@isStriped}}
        @targetValue={{if (notEq @targetValue null) @targetValuePercentage}}
        as |DataBar|
      >
        <DataBar.label @text={{@item.displayValue}} />
        <DataBar.value @text="{{@value}}" />
      </PrismDataBar>
    {{/if}}
  </template> satisfies TOC<HotelAndMarketRevenueInsightSegmentationSegmentationItemCurrentValueSignature>;

export default HotelAndMarketRevenueInsightSegmentationSegmentationItemCurrentValue;
